import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEN from './locales/en/translation.json';
import translationFR from './locales/fr/translation.json';
// the translations
const resources = {
    en: {
        translation: translationEN,
    },
    fr: {
        translation: translationFR,
    },
};
const i18n = i18next.createInstance();
i18n
    // .use(initReactI18next) // passes i18n down to react-i18next
    .use(LanguageDetector) // detect browser language
    .init({
    resources,
    react: { useSuspense: false }, //this line
    fallbackLng: 'en', // fallback language
    joinArrays: '\n',
    interpolation: {
        escapeValue: false, // react already safes from xss
    },
    returnNull: false,
});
i18n.on('languageChanged', () => (document.documentElement.lang = i18n.resolvedLanguage ?? 'en'));
export default i18n;
